import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Divider,
} from '@mui/material';
import {
  TrendingUp as AnalyticsIcon,
  Group as CommunityIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const QuickAccess = () => {
  const navigate = useNavigate();

  const quickLinks = [
    {
      title: 'AI Analysis',
      description: 'Analyze LSAT questions with AI',
      icon: <AnalyticsIcon sx={{ color: '#4F46E5' }} />,
      action: () => navigate('/dashboard/analyze'),
    },
    {
      title: 'Community', 
      description: 'Join study groups',
      icon: <CommunityIcon sx={{ color: '#b65f3b' }} />,
      action: () => navigate('/dashboard/community'),
    }
  ];

  return (
    <Card>
      <CardHeader title="Quick Access" />
      <CardContent>
        <List>
          {quickLinks.map((link, index) => (
            <React.Fragment key={link.title}>
              <ListItem disablePadding>
                <ListItemButton onClick={link.action}>
                  <ListItemIcon>{link.icon}</ListItemIcon>
                  <ListItemText
                    primary={link.title}
                    secondary={link.description}
                  />
                </ListItemButton>
              </ListItem>
              {index < quickLinks.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};

export default QuickAccess; 